import React, { useState, useEffect, useMemo } from "react";
import { Table, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import ExportToExcel from "./ExportToExcel";
import Pagination from "./Pagination";
import SearchBar from "./SearchBar";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import Dynamic_FilterForm from "./Dynamic_FilterForm";
import { useSelector } from "react-redux";
import { FaSpinner } from "react-icons/fa";
const NewDynamic_PR_table = ({
  data,
  selectedResource,
  selectAllChecked,
  columns,

  responseStatus,
  handleBtn,
  itemsPerPage,
  searchTerm,
  setSearchTerm,
  handleIconClick,
  handleModalColumn,
  icons,
  isActionRequired,
  isCheckBoxRequired,
  isAddNewBtnRequired,
  isFilterRequired,
  isSorting,
  formDatas,
  showIcon1,
  showIcon2,
  showIcon3,
  showIcon4,
  showIcon5,
  handleIcon1,
  handleIcon2,
  handleIcon3,
  handleIcon4,
  handleIcon5,
  handleGetData,
  handleAddNew,
  handleChange,
  filterFormData,
  handleCheckboxChange,
  handleSelectAllChange,
}) => {
  const [visibleColumns, setVisibleColumns] = useState(
    Object.keys(columns).reduce((acc, key) => {
      acc[key] = columns[key].visible; // Set initial visibility based on the 'visible' key
      return acc;
    }, {})
  );

  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });

  const ExcelName = useSelector(
    ({ layoutReducer }) => layoutReducer?.filterSlice?.navbarHeading
  );

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const toggleColumn = (columnName) => {
    setVisibleColumns((prevState) => ({
      ...prevState,
      [columnName]: !prevState[columnName], // Toggle visibility
    }));
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const navigate = useNavigate();

  const sortedData = useMemo(() => {
    let sortableItems = [...(data || [])];
    if (sortConfig !== null) {
      sortableItems.sort((a, b) => {
        const valA = a[sortConfig.key] ? String(a[sortConfig.key]) : "";
        const valB = b[sortConfig.key] ? String(b[sortConfig.key]) : "";

        // Split the values into alphabetical and numeric parts
        const partsA = valA.match(/(\D+|\d+)/g) || [];
        const partsB = valB.match(/(\D+|\d+)/g) || [];

        for (let i = 0; i < Math.max(partsA.length, partsB.length); i++) {
          const partA = partsA[i] || "";
          const partB = partsB[i] || "";

          // Determine if parts are numeric or alphabetical
          const isNumericA = !isNaN(partA);
          const isNumericB = !isNaN(partB);

          if (isNumericA && isNumericB) {
            // Both parts are numeric, so compare as numbers
            const numA = parseInt(partA, 10);
            const numB = parseInt(partB, 10);
            if (numA !== numB) {
              return sortConfig.direction === "ascending"
                ? numA - numB
                : numB - numA;
            }
          } else if (isNumericA || isNumericB) {
            // One part is numeric and the other is alphabetical
            return isNumericA ? -1 : 1;
          } else {
            // Both parts are alphabetical, so compare as strings
            if (partA !== partB) {
              return sortConfig.direction === "ascending"
                ? partA.localeCompare(partB)
                : partB.localeCompare(partA);
            }
          }
        }

        return 0;
      });
    }
    return sortableItems;
  }, [data, sortConfig]);

  const filteredData = sortedData.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, filteredData.length);
  const currentData = filteredData.slice(startIndex, endIndex);

  const handleSort = (columnName) => {
    let direction = "ascending";
    if (
      sortConfig &&
      sortConfig.key === columnName &&
      sortConfig.direction === "ascending"
    ) {
      direction = "descending";
    }
    setSortConfig({ key: columnName, direction });
  };

  //old code for date fromat
  // const formatDate = (date) => {
  //   if (!date) return ""; // Handle null or undefined dates

  //   // Check if the date is already in DD-MM-YYYY format
  //   const dateRegex = /^\d{2}-\d{2}-\d{4}$/;
  //   if (dateRegex.test(date)) {
  //     return date;
  //   }

  //   return moment(date).format("DD-MMM-YYYY");
  // };

  //new updateed code for date fromat
  const formatDate = (date) => {
    if (!date) return ""; // check date is null or undefined

    // Use moment
    const parsedDate = moment(
      date,
      [
        moment.ISO_8601, // Handles ISO date formats
        "DD-MM-YYYY", // Specific format check
        "MM/DD/YYYY", // U.S. format
        "YYYY-MM-DD", // Standard format
        "DD-MMM-YYYY", // Standard format
        "DD-MMM-YYYY hh:mm", // Standard format
      ],
      true
    );

    // Return formatted date if valid, otherwise an empty string
    return parsedDate.isValid() ? parsedDate.format("DD-MMM-YYYY") : "";
  };

  return (
    <div className="container-fluid ">
      <div className="d-flex justify-content-between">
        <div className="d-flex">
          <div className="me-1">
            <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
          </div>
          {isFilterRequired && (
            <div className="dropdown">
              <OverlayTrigger
                placement="right"
                overlay={<Tooltip id="tooltip-bottom">Filters</Tooltip>}
              >
                <button
                  className="dropdown-toggle"
                  type="button"
                  id="excel-btn"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="bi bi-funnel-fill"></i>
                </button>
              </OverlayTrigger>

              <div>
                <Dynamic_FilterForm
                  formData={formDatas || []}
                  handleChange={handleChange}
                  handleGetData={handleGetData}
                  filterFormData={filterFormData}
                />
              </div>
            </div>
          )}
        </div>

        <div className="d-flex justify-content-end">
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="tooltip-top">Export to Excel</Tooltip>}
          >
            <div className="me-1">
              <ExportToExcel
                data={filteredData}
                filename={`${ExcelName}.csv`}
              />
            </div>
          </OverlayTrigger>
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="tooltip-top">Column Chooser</Tooltip>}
          >
            <div className="btn-group me-2">
              <button
                type="button"
                className="dropdown-toggle skill-button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                id="excel-btn"
              >
                <i className="bi bi-list"></i>
              </button>
              <ul className="dropdown-menu p-2">
                <div className="row">
                  <Form.Group>
                    {Object.keys(columns).map((columnName) => (
                      <Form.Check
                        key={columnName}
                        type="checkbox"
                        id={`checkbox-${columnName}`}
                        label={columns[columnName].text} // Display the column name using 'text' key
                        checked={visibleColumns[columnName] || false} // Use 'visible' key to control the checked state
                        onChange={() => toggleColumn(columnName)} // Toggle visibility on change
                      />
                    ))}
                  </Form.Group>
                </div>
              </ul>
            </div>
          </OverlayTrigger>
          {isAddNewBtnRequired && (
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id="tooltip-top">Add New</Tooltip>}
            >
              <button id="Add-btn" onClick={handleAddNew}>
                <i className="fa fa-plus"></i> Add
              </button>
            </OverlayTrigger>
          )}
        </div>
      </div>

      <div className=" ">
        <div className="table-responsive  mb-2">
          <Table striped bordered hover>
            <thead id="thcolor" className="text-center">
              <tr>
                {isCheckBoxRequired && (
                  <th style={{ width: "25px" }}>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={selectAllChecked}
                      onChange={(e) => handleSelectAllChange(e)}
                    />
                  </th>
                )}
                {Object.keys(columns).map((columnName) => {
                  const isDateColumn = [
                    "date",
                    "applied date",
                    "created date",
                    "on bench since",
                  ].some((dateKeyword) =>
                    columns[columnName].text.toLowerCase().includes(dateKeyword)
                  );

                  const columnAlignment = columns[columnName].align || "left";
                  const columnWidth = columns[columnName].width;

                  const isButtonColumn = columns[columnName].type === "button";
                  const isModalColumn = columns[columnName].type === "Modal";
                  const isImageColumn = columns[columnName].type === "Image";
                  const hasIcon = columns[columnName].icon;

                  return (
                    visibleColumns[columnName] && (
                      <th
                        style={{ whiteSpace: "nowrap" }}
                        key={columnName}
                        onClick={
                          isSorting &&
                          (isButtonColumn || isModalColumn || hasIcon)
                            ? undefined
                            : () => handleSort(columnName)
                        }
                      >
                        {columns[columnName].text}
                        {isSorting &&
                          !(isButtonColumn || isModalColumn || hasIcon) && (
                            <span className="ms-1">
                              {sortConfig.key === columnName ? (
                                sortConfig.direction === "ascending" ? (
                                  <i className="bi bi-arrow-up"></i>
                                ) : (
                                  <i className="bi bi-arrow-down"></i>
                                )
                              ) : (
                                <i className="bi bi-arrow-down"></i>
                              )}
                            </span>
                          )}
                      </th>
                    )
                  );
                })}
                {isActionRequired && <th>Action</th>}
              </tr>
            </thead>
            {currentData?.length !== 0 && responseStatus === 200 ? (
              <tbody>
                {currentData.map((item, index) => (
                  <tr key={index}>
                    {isCheckBoxRequired && (
                      <td>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={
                            !!selectedResource.find(
                              (o) => o.EmployeeID === item.EmployeeID
                            )
                          }
                          onChange={(e) =>
                            handleCheckboxChange(e, item.EmployeeID, item)
                          }
                        />
                      </td>
                    )}
                    {Object.keys(columns).map((columnName) => {
                      const isDateColumn =
                        columns[columnName].text
                          .toLowerCase()
                          .includes("date") ||
                        columns[columnName].text
                          .toLowerCase()
                          .includes("on bench since");

                      const columnAlignment =
                        columns[columnName].align || "left";
                      const columnWidth = columns[columnName].width;

                      const isButtonColumn =
                        columns[columnName].type === "button";
                      const isModalColumn =
                        columns[columnName].type === "Modal";
                      const isImageColumn =
                        columns[columnName].type === "Image";
                      const isButtonName = columns[columnName].text;
                      const hasIcon = columns[columnName].icon;

                      return (
                        visibleColumns[columnName] &&
                        (item[columnName] !== null &&
                        item[columnName] !== undefined ? (
                          <OverlayTrigger
                            key={columnName}
                            placement="right"
                            overlay={
                              <Tooltip id={`tooltip-${columnName}`}>
                                {isDateColumn
                                  ? formatDate(item[columnName])
                                  : item[columnName]}
                              </Tooltip>
                            }
                          >
                            <td
                              className={`text-${columnAlignment} text-truncate`}
                              style={{
                                maxWidth: columnWidth || "100px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {isButtonColumn ? (
                                <button
                                  className={`text-${columnAlignment} custom-btn`}
                                  onClick={() => handleBtn(columnName, item)}
                                >
                                  {isButtonName}
                                </button>
                              ) : hasIcon ? (
                                <div
                                  className="d-flex align-items-center justify-content-center text-center"
                                  onClick={() =>
                                    handleIconClick(columnName, item)
                                  }
                                >
                                  <span className="me-2">
                                    {icons[columns[columnName].icon]}
                                  </span>
                                  {item[columnName]}
                                </div>
                              ) : isDateColumn ? (
                                formatDate(item[columnName])
                              ) : isModalColumn ? (
                                <a
                                  style={{ cursor: "pointer" }}
                                  className="text-primary text-decoration-none"
                                  onClick={() =>
                                    handleModalColumn(columnName, item)
                                  }
                                >
                                  {" "}
                                  {item[columnName]}
                                </a>
                              ) : isImageColumn ? (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "50px",
                                      height: "50px",
                                      borderRadius: "50%",
                                      backgroundColor: "gray",
                                    }}
                                  ></div>
                                </div>
                              ) : (
                                item[columnName]
                              )}
                            </td>
                          </OverlayTrigger>
                        ) : (
                          <td
                            key={columnName}
                            className={`text-${columnAlignment} text-truncate`}
                            style={{
                              maxWidth: columnWidth || "60px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {isButtonColumn ? (
                              <button
                                className={`text-${columnAlignment} custom-btn`}
                                onClick={() => handleBtn(columnName, item)}
                              >
                                {isButtonName}
                              </button>
                            ) : hasIcon ? (
                              // <OverlayTrigger
                              //   placement="bottom"
                              //   overlay={
                              //     <Tooltip id="tooltip-bottom">
                              //       {item[columns[columnName].iconText] || "Edit"}
                              //     </Tooltip>
                              //   }
                              // >
                              <div
                                className="d-flex align-items-center justify-content-center text-center"
                                onClick={() =>
                                  handleIconClick(columnName, item)
                                }
                              >
                                <span className="me-2">
                                  {icons[columns[columnName].icon]}
                                </span>
                                {item[columnName]}
                              </div>
                            ) : // </OverlayTrigger>
                            isDateColumn ? (
                              formatDate(item[columnName])
                            ) : (
                              item[columnName]
                            )}
                          </td>
                        ))
                      );
                    })}
                    {isActionRequired && (
                      <td>
                        <div className="d-flex justify-content-center text-center">
                          {showIcon1 && (
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id="tooltip-bottom">
                                  {icons.Icon1Text || "Edit"}
                                </Tooltip>
                              }
                            >
                              <div
                                className="me-2"
                                onClick={() => handleIcon1(item)}
                              >
                                {icons.Icon1}
                              </div>
                            </OverlayTrigger>
                          )}
                          {showIcon2 && (
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id="tooltip-bottom">
                                  {icons.Icon2Text || "Edit"}
                                </Tooltip>
                              }
                            >
                              <div
                                className="me-2"
                                onClick={() => handleIcon2(item)}
                              >
                                {icons.Icon2}
                              </div>
                            </OverlayTrigger>
                          )}
                          {showIcon3 && (
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id="tooltip-bottom">
                                  {icons.Icon3Text}
                                </Tooltip>
                              }
                            >
                              <div
                                className="me-2"
                                onClick={() => handleIcon3(item)}
                              >
                                {icons.Icon3}
                              </div>
                            </OverlayTrigger>
                          )}
                          {showIcon4 && (
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id="tooltip-bottom">
                                  {icons.Icon4Text || "Add"}
                                </Tooltip>
                              }
                            >
                              <div
                                className="me-2"
                                onClick={() => handleIcon4(item)}
                              >
                                {icons.Icon4}
                              </div>
                            </OverlayTrigger>
                          )}
                          {showIcon5 && (
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id="tooltip-bottom">
                                  {icons.Icon5Text || "Add"}
                                </Tooltip>
                              }
                            >
                              <div
                                className="me-2"
                                onClick={() => handleIcon5(item)}
                              >
                                {icons.Icon5}
                              </div>
                            </OverlayTrigger>
                          )}
                        </div>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            ) : currentData?.length === 0 && responseStatus !== 200 ? (
              <tbody>
                <tr>
                  <td
                    colSpan={
                      Object.keys(columns).length +
                      (isCheckBoxRequired ? 1 : 0) +
                      (isActionRequired ? 1 : 0)
                    }
                    className="text-center"
                  >
                    <div>
                      <p>
                        <FaSpinner class="spinner" />
                        <br />
                        Loading
                      </p>
                    </div>
                  </td>
                </tr>
              </tbody>
            ) : currentData?.length === 0 && responseStatus === 200 ? (
              <tbody>
                <tr>
                  <td
                    colSpan={
                      Object.keys(columns).length +
                      (isCheckBoxRequired ? 1 : 0) +
                      (isActionRequired ? 1 : 0)
                    }
                    className="text-center"
                  >
                    <div>
                      <p>No Record Found</p>
                    </div>
                  </td>
                </tr>
              </tbody>
            ) : null}
          </Table>
        </div>
        {/* {filteredData.length > itemsPerPage && ( */}
        <div className="d-flex justify-content-end">
          <Pagination
            itemsPerPage={itemsPerPage}
            totalItems={filteredData.length}
            currentPage={currentPage}
            onPageChange={handlePageChange}
          />
        </div>
        {/* )} */}
      </div>
    </div>
  );
};

export default NewDynamic_PR_table;
